export interface PaymentIntent {
    id?: string;
    customerEmail: string;
    insurancePolicyId: string;
    isAboveMaxPolicy: boolean;
    gatewayClientSecret?: string;
    status?: PaymentIntentStatus;
}

export enum PaymentIntentStatus {
    New = 'New',
    Registered = 'Registered',
    IntentCanceled = 'IntentCanceled',
    TimedOut = 'TimedOut',
    SubmittedForCapture = 'SubmittedForCapture',
    CaptureFailed = 'CaptureFailed',
    CaptureComplete = 'CaptureComplete',
    RefundIssued = 'RefundIssued',
    PaymentDisputed = 'PaymentDisputed',
    Faulted = 'Faulted',
}
